import { ChevronRight } from "lucide-react";
import React from "react";
import Tooltip from "../../../Tooltip";
import { useIsOverflowing } from "./hooks";
import { BaseBreadcrumbConstrainedWidthContainerStyles, BaseBreadcrumbLink, BaseBreadcrumbListItem, BaseBreadcrumbText } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Breadcrumb(_ref) {
  var href = _ref.href,
    target = _ref.target,
    text = _ref.text,
    isLastItem = _ref.isLastItem,
    linkComponent = _ref.linkComponent;
  var _useIsOverflowing = useIsOverflowing(),
    overflowContainerRef = _useIsOverflowing.overflowContainerRef,
    isOverflowing = _useIsOverflowing.isOverflowing;
  return /*#__PURE__*/_jsxs(BaseBreadcrumbListItem, {
    children: [isLastItem ? /*#__PURE__*/_jsx(BaseBreadcrumbConstrainedWidthContainerStyles, {
      ref: overflowContainerRef,
      children: isOverflowing ? /*#__PURE__*/_jsx(Tooltip, {
        preferredSide: "top",
        preferredAlignment: "start",
        content: text,
        children: /*#__PURE__*/_jsx(BaseBreadcrumbText, {
          "aria-current": "page",
          children: text
        })
      }) : /*#__PURE__*/_jsx(BaseBreadcrumbText, {
        children: text
      })
    }) : linkComponent && /*#__PURE__*/_jsx(BaseBreadcrumbLink, {
      as: "span",
      children: linkComponent
    }) || /*#__PURE__*/_jsx(BaseBreadcrumbLink, {
      href: href,
      target: target,
      children: text
    }), isLastItem ? null : /*#__PURE__*/_jsx(ChevronRight, {
      size: "0.875rem"
    })]
  });
}
export default Breadcrumb;